// import { take, call, put, select } from 'redux-saga/effects';

// Individual exports for testing
import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import * as Types from "./constants";
import * as genericTypes from "./constants";
import axios from "axios";
import history from "../utilize/history";
import Apis from "constants/Api";

function* signIn({ payload }) {
  try {
    const formData = new FormData();
    formData.append("username", payload.username);
    formData.append("password", payload.password);
    formData.append("prefix", "a");
    const res = yield call(
      axios.post,
      "https://backend.ayandehsazan.ir/login/",
      formData,
      {
        headers: { "content-type": "multipart/form-data" },
      }
    );
    yield put({
      type: Types.SIGN_IN_SUCCESS,
      payload: res.data.token,
    });
    yield put({
      type: genericTypes.TOAST_SUCCESS,
      payload: { message: "شما با موفقیت وارد شدید" },
    });
    localStorage.setItem("aghighToken", res.data.token);
    history.push("/");
  } catch (error) {
    yield put({
      type: Types.SIGN_IN_FAILED,
      payload: error?.response?.data?.detail,
    });
    if (error?.response?.status === 404) {
      yield put({
        type: Types.TOAST_ERROR,
        payload: {
          message:
            "شما ثبت‌نام نکرده‌اید، لطفا از گزینه ثبت‌‌نام استفاده نمایید ",
        },
      });
    } else if (error?.response?.status === 401) {
      yield put({
        type: Types.TOAST_ERROR,
        payload: {
          message:
            "کدملی یا رمز عبور شما اشتباه است. لطفا از گزینه فراموشی رمز عبور استفاده نمایید",
        },
      });
    } else {
      yield put({
        type: Types.TOAST_ERROR,
        payload: { message: "ورود شما با خطا مواجه شده است" },
      });
    }
  }
}

function* getProfileDetail({ payload }) {
  try {
    const res = yield call(
      axios.get,
      "https://backend.ayandehsazan.ir/a/org/get-user/",
      {
        headers: {
          Authorization: `token ${localStorage.getItem("aghighToken")}`,
        },
      }
    );
    yield put({
      type: Types.GET_PROFILE_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    yield put({
      type: Types.TOAST_ERROR,
      payload: { message: "دریافت اطلاعات کاربر با خطا مواجه شده است" },
    });
  }
}

function* getLatestSearchResult({ payload }) {
  try {
    const res = yield call(
      axios.get,
      `https://backend.ayandehsazan.ir/a/act/search-history/`,
      {
        headers: {
          Authorization: `token ${localStorage.getItem("aghighToken")}`,
        },
      }
    );
    yield put({
      type: Types.GET_SEARCH_HISTORY_RESULT_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    yield put({
      type: Types.GET_SEARCH_HISTORY_RESULT_FAILED,
    });
  }
}

function* setNotificationsSeen({ payload }) {
  try {
    const formData = new FormData();
    formData.append("notification_id", payload.notificationId);

    const res = yield call(
      axios.post,
      "https://backend.ayandehsazan.ir/a/msg/set-notification-seen/",
      formData,
      {
        headers: {
          Authorization: `token ${localStorage.getItem("aghighToken")}`,
        },
      }
    );
    yield put({
      type: Types.SET_NOTIFICATIONS_SEEN_SUCCESS,
      payload: payload,
    });
  } catch (error) {
    yield put({
      type: Types.TOAST_ERROR,
      payload: { message: "حذف یادآور با خطا مواجه شده است" },
    });
    yield put({
      type: Types.SET_NOTIFICATIONS_SEEN_FAILED,
      payload: payload,
    });
  }
}

//activities list
function* getMyBoomList({ payload }) {
  try {
    const res = yield call(axios.get, Apis.GET_MY_BOOM + `${payload}`, {
      headers: {
        Authorization: `token ${localStorage.getItem("aghighToken")}`,
      },
    });
    yield put({
      type: Types.GET_MY_BOOM_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    yield put({
      type: Types.GET_MY_BOOM_FAILED,
    });
  }
}

function* getExtraMyBoomList({ payload }) {
  try {
    const res = yield call(
      axios.get,
      payload.pageTo
        ? Apis.GET_MY_BOOM + `${payload.pageFrom}&page_to=${payload.pageTo}`
        : Apis.GET_MY_BOOM + `${payload.pageFrom}`,
      {
        headers: {
          Authorization: `token ${localStorage.getItem("aghighToken")}`,
        },
      }
    );
    yield put({
      type: Types.GET_EXTRA_MY_BOOM_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: Types.GET_EXTRA_MY_BOOM_FAILED,
    });
  }
}

function* getActivitySearchList({ payload }) {
  try {
    const res = yield call(
      axios.get,
      payload?.pageTo
        ? Apis.GET_ACTIVITY_SEARCH +
            `layer=${payload.layer}&province=${payload.province}&county=${payload.county}&order=${payload.order}&gender=${payload.gender}&q=${payload.q}&category=${payload.category}&subject=${payload.subject}&start_date=${payload.startDate}&finish_date=${payload.endDate}&page_from=${payload.pageFrom}&page_to=${payload.pageTo}`
        : Apis.GET_ACTIVITY_SEARCH +
            `layer=${payload.layer}&province=${payload.province}&county=${payload.county}&order=${payload.order}&gender=${payload.gender}&q=${payload.q}&category=${payload.category}&subject=${payload.subject}&start_date=${payload.startDate}&finish_date=${payload.endDate}&page_from=${payload.pageFrom}`,
      {
        headers: {
          Authorization: `token ${localStorage.getItem("aghighToken")}`,
        },
      }
    );
    yield put({
      type: Types.GET_ACTIVITY_SEARCH_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: Types.GET_ACTIVITY_SEARCH_FAILED,
    });
  }
}

function* getExtraActivitySearchList({ payload }) {
  try {
    const res = yield call(
      axios.get,
      payload?.pageTo
        ? Apis.GET_ACTIVITY_SEARCH +
            `layer=${payload.layer}&province=${payload.province}&county=${payload.county}&order=${payload.order}&gender=${payload.gender}&page_from=${payload.pageFrom}&page_to=${payload.pageTo}`
        : Apis.GET_ACTIVITY_SEARCH +
            `layer=${payload.layer}&province=${payload.province}&county=${payload.county}&order=${payload.order}&gender=${payload.gender}&page_from=${payload.pageFrom}`,
      {
        headers: {
          Authorization: `token ${localStorage.getItem("aghighToken")}`,
        },
      }
    );
    yield put({
      type: Types.GET_EXTRA_ACTIVITY_SEARCH_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: Types.GET_EXTRA_ACTIVITY_SEARCH_FAILED,
    });
  }
}

function* getMyActivity({ payload }) {
  console.log(payload, "my activity payload");
  try {
    const res = yield call(
      axios.get,
      Apis.GET_MY_ACTIVITY + `&page_from=${payload.pageFrom}`,
      {
        headers: {
          Authorization: `token ${localStorage.getItem("aghighToken")}`,
        },
      }
    );
    yield put({
      type: Types.GET_MY_ACTIVITY_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error, "edewdwe");
    yield put({
      type: Types.GET_MY_ACTIVITY_FAILED,
    });
  }
}

function* getMyFallowing() {
  try {
    const res = yield call(axios.get, Apis.GET_MY_FOLLOWING, {
      headers: {
        Authorization: `token ${localStorage.getItem("aghighToken")}`,
      },
    });
    yield put({
      type: Types.GET_MY_FOLLOWING_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: Types.GET_MY_FOLLOWING_FAILED,
    });
  }
}
function* getSuggestedFollowingList() {
  try {
    const res = yield call(axios.get, Apis.GET_SUGGESTED_FOLLOWING, {
      headers: {
        Authorization: `token ${localStorage.getItem("aghighToken")}`,
      },
    });
    yield put({
      type: Types.GET_SUGGESTED_FOLLOWING_LIST_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: Types.GET_SUGGESTED_FOLLOWING_LIST_FAILED,
    });
  }
}
//home page
function* getHomeData() {
  try {
    let res;
    if (localStorage.getItem("aghighToken")) {
      res = yield call(axios.get, Apis.GET_HOME_DATA, {
        headers: {
          Authorization: `token ${localStorage.getItem("aghighToken")}`,
        },
      });
    } else {
      res = yield call(axios.get, Apis.GET_HOME_DATA);
    }

    yield put({
      type: Types.HOME_DATA_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    yield put({
      type: Types.HOME_DATA_FAILED,
    });
  }
}
//school page
function* getMoreSchoolActivities({ payload }) {
  try {
    let res = yield call(
      axios.get,
      payload?.pageTo
        ? Apis.baseUrl +
            `a/act/${payload.unit}-activity-list-load-more/${payload.slug}/?page_from=${payload.pageFrom}&page_to=${payload.pageTo}`
        : Apis.baseUrl +
            `a/act/${payload.unit}-activity-list-load-more/${payload.slug}/?page_from=${payload.pageFrom}`,
      {
        headers: {
          Authorization: `token ${localStorage.getItem("aghighToken")}`,
        },
      }
    );

    yield put({
      type: Types.SCHOOL_DATA_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    yield put({
      type: Types.SCHOOL_DATA_FAILED,
    });
  }
}

function* pobSaga() {
  yield takeLatest(Types.SIGN_IN_REQUESTED, signIn);
  yield takeEvery(Types.GET_PROFILE_REQUESTED, getProfileDetail);
  yield takeEvery(
    Types.GET_SEARCH_HISTORY_RESULT_REQUESTED,
    getLatestSearchResult
  );
  yield takeEvery(Types.SET_NOTIFICATIONS_SEEN_REQUESTED, setNotificationsSeen);
  yield takeLatest(Types.GET_MY_BOOM_REQUESTED, getMyBoomList);
  yield takeLatest(Types.GET_EXTRA_MY_BOOM_REQUESTED, getExtraMyBoomList);
  yield takeLatest(Types.GET_ACTIVITY_SEARCH_REQUESTED, getActivitySearchList);
  yield takeEvery(
    Types.GET_EXTRA_ACTIVITY_SEARCH_REQUESTED,
    getExtraActivitySearchList
  );
  yield takeLatest(Types.GET_MY_ACTIVITY_REQUESTED, getMyActivity);
  yield takeLatest(Types.GET_MY_FOLLOWING_REQUESTED, getMyFallowing);
  yield takeLatest(
    Types.GET_SUGGESTED_FOLLOWING_LIST_REQUESTED,
    getSuggestedFollowingList
  );
  yield takeEvery(Types.HOME_DATA_REQUESTED, getHomeData);
  yield takeEvery(Types.SCHOOL_DATA_REQUESTED, getMoreSchoolActivities);
}

export default pobSaga;
